let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4TInl")).then(() => parcelRequire('cu1WA'));